import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
declare global {
  interface Window {
    loadDataCalendar: () => void;
  }
}
const handleCalendar = () => {
  const myCalendarDiv = document.getElementById('myCalendar');
  let script = document.getElementById('myCalendarScript') as HTMLScriptElement;
  if (!script) {
    script = document.createElement('script');
    script.src = `https://widget.s3.sbg.perf.cloud.ovh.net/calendario-subito/widget.min.js?site=subito` + `&amp;random=${new Date().getDate()}${new Date().getMonth()}`;
    script.id = 'myCalendarScript';
    script.onload = () => {
      if (typeof window.loadDataCalendar == 'function') {
        window.loadDataCalendar();
      }
    };
    myCalendarDiv?.appendChild(script);
  }
};
export function useCalendar() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      handleCalendar
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2() {
  return _temp;
}
function _temp() {
  const script = document.getElementById("myCalendarScript");
  if (script) {
    script.remove();
  }
}